<template>
    <div class="mainpage">
        <div class="whitebox">
            <input v-model="key" placeholder="Manager Key"/><br/>
            <button @click="validate">Validate</button>
        </div>
    </div>
</template>

<script>
    import util from "../../util"
    import config from "../../config"
    export default {
        name: "manager-validate",
        data(){
            return {
                key:''
            }
        },
        methods:{
            validate(){
                util.axios.post(config.do_manager_validate_url,{password:this.key}).then(()=>{
                    this.$router.push('/manager')
                })
            }
        }
    }
</script>

<style scoped>

</style>